import log from '../../utils/logger'
import { AdBannerEvent, Empire } from '../../constants'
import { CXF } from '@goodgamestudios/cxf-runtime'
import { GameEventTriggerType, UpdatePaymentEventData } from '../game-controller'

let cxf: CXF
let gameEventTrigger: GameEventTriggerType

const registerUpdatePay = () => {
  cxf.on(Empire.UPDATE_PAY, (eventData: string[]) => {
    const [serverResponse] = eventData
    const responseAsJSON = serverResponse[1]
    const paymentData = JSON.parse(responseAsJSON) as UpdatePaymentEventData
    gameEventTrigger(AdBannerEvent.UPDATE_PAY, paymentData)
  })
}

const registerCustomGameHandlers = (context: CXF, rootGameEventTrigger: GameEventTriggerType) => {
  log('EM - registerCustomGameHandlers')
  cxf = context
  gameEventTrigger = rootGameEventTrigger

  registerUpdatePay()
}

const emController = {
  registerCustomGameHandlers,
}

export default emController
